import axios_http from 'axios';
// import devApi from './devApi';
import store from './../store/store';

const appConfig = () => {
    return store.getters["config/data"];
};
const axios = axios_http;

axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  // Do something with response error
  if (error.response.status === 500) {
      alert('We seem to have had an error on our end... please try again later or report the bug if it persists.');
  }
  if (error.response.status === 401) {
      alert("The page you are trying to view either doesn't exist or requires an escalated role.");
      alert('Unauthorized');
      window.history.back();
  }
  return Promise.reject(error.response);
});

//var url = ;
var api = {
    // config: {
    //     base: url + '/user/web',
    //     authBase: url + '/auth',
    //     version: url
    // },
    getVersion: () => {
        const url = appConfig().api.url + '/service/site/user/web/version';
        return axios.get(url, null);
    },
    baseUrl: () => {
        return appConfig().api.url + '/user/web';
    },
    auth: (path, data) => {
        const url = appConfig().api.url + '/auth' + path;
        return axios.post(url, data);
    },
    authGet: (path) => {
        const url = appConfig().api.url + '/auth' + path;
        return axios.get(url, null);
    },
    get: (path, params) => {
        const url = appConfig().api.url + '/user/web' + path;
        return axios.get(url, params);
    },
    post: (path, data) => {
        const url = appConfig().api.url + '/user/web' + path;
        return axios.post(url, data);
    },
    patch: (path, data) => {
        const url = appConfig().api.url + '/user/web' + path;
        return axios.patch(url, data);
    },
    delete: (path, data) => {
        const url = appConfig().api.url + '/user/web' + path;
        const payload = {
            data: data
        };
        return axios.delete(url, payload);
    },
    postFile: (path, file) => {
        const url = appConfig().api.url + '/user/web' + path;
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        });
    },
    setCommonHeader: (header, value) => {
        axios.defaults.headers.common[header] = value;
    },
    removeCommonHeader: (key) => {
        delete axios.defaults.headers.common[key];
    }
};

export default api;
